import $ from "jquery";
import ScrollMagic from "scrollmagic";
import VueTaaf from "../app";
import {throttle} from "lodash";

export default {
    controller: new ScrollMagic.Controller(),
    init() {
        this.initMenuScroll()
    },
    initMenuScroll() {


        new ScrollMagic.Scene({
            triggerElement: "body",
            triggerHook: 0,
            offset: 10,
        })
            .addTo(this.controller)
            // .addIndicators() // add indicators (requires plugin)
            .on("enter", function (event) {
                VueTaaf.headerTransparent = true
            })
            .on("leave", function (event) {
                VueTaaf.headerTransparent = false
            })
            .on("update", (e) => {
                var direction = this.controller.info("scrollDirection");
                let hideOkToggle = (e.scrollPos >= e.startPos);
                if (!hideOkToggle) {
                    this.HandleHearderVisibility(true)
                    return
                }

                this.HandleHearderVisibility(direction === "REVERSE")

            });

    },
    HandleHearderVisibility: throttle(function (value) {
        VueTaaf.headerVisibility = value
    }, 300)


};